const src = import.meta.ROLLUP_FILE_URL_UtSd2wWiGs0Sim15oE6Xxg;
export default {
  src,
  srcSet: src + " " + 324 + "w",
  width: 324,
  height: 480,
};